import { ScheduleSegment } from "@models/ScheduleSegment.model";
import { CommandGetScheduleTree } from "./commands/CmdGetScheduleTree";
import { CommandUpdateScheduleSegment } from "./commands/CmdUpdateScheduleSegment";
import { CommandCreateScheduleSegment } from "./commands/CmdCreateScheduleSegment";
import { CommandDeleteScheduleSegment } from "./commands/CmdDeleteScheduleSegment";
import { ScheduleEntry } from "@models/ScheduleEntry.model";
import { CommandUpdateScheduleEntry } from "./commands/CmdUpdateScheduleEntry";
import { CommandCreateScheduleEntry } from "./commands/CmdCreateScheduleEntry";
import { CommandDuplicateScheduleEntry } from "./commands/CmdDuplicateScheduleEntry";
import { CommandDeleteScheduleEntry } from "./commands/CmdDeleteScheduleEntry";
import { CmdGetEntryDuration, type EntryDurationResponse } from "./commands/CmdGetEntryDuration";

export class ScheduleService {
  async getScheduleTree(scheduleId: number) {
    const cmd = new CommandGetScheduleTree();
    const results = await cmd.run(scheduleId);
    return results;
  }

  async createScheduleEntry(entry: Partial<ScheduleEntry>) {
    const cmd = new CommandCreateScheduleEntry();
    return await cmd.run(entry)
  }

  async updateScheduleEntry(entryId: number, entry: Partial<ScheduleEntry>) {
    const cmd = new CommandUpdateScheduleEntry();
    const results = await cmd.run(entryId, entry)
    return results
  }

  async duplicateScheduleEntry(entryId: number, entry: Partial<ScheduleEntry>) {
    const cmd = new CommandDuplicateScheduleEntry();
    const results = await cmd.run(entryId, entry)
    return results
  }

  async deleteScheduleEntry(entryId: number) {
    const cmd = new CommandDeleteScheduleEntry();
    await cmd.run(entryId)
  }

  async updateScheduleSegment(segmentId: number, segment: ScheduleSegment) {
    const cmd = new CommandUpdateScheduleSegment();
    const results = await cmd.run(segmentId, segment);
    return results;
  }

  async createScheduleSegment(segment: ScheduleSegment) {
    const cmd = new CommandCreateScheduleSegment();
    const results = await cmd.run(segment);
    return results;
  }

  async deleteScheduleSegment(segmentId: number) {
    const cmd = new CommandDeleteScheduleSegment();
    const results = await cmd.run(segmentId);
    return results;
  }

  async getEntryDuration(entryId: number): Promise<EntryDurationResponse> {
    const cmd = new CmdGetEntryDuration();
    return await cmd.run(entryId);
  }
}
